import styles from './ScreenTitle.module.css';

interface ScreenTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}

const ScreenTitle = ({ className, ...props }: ScreenTitleProps): React.JSX.Element => (
    <h1 className={`${styles.screenTitle}${className ? ` ${className}` : ''}`} {...props} />
);

export { ScreenTitle };
